import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import LandingCtaButton from '~/landingV4/components/LandingCtaButton'
import SectionContainer from '~/landingV4/components/SectionContainer'

interface Confetti {
  color: string
  left: string
  size: string
  top: string
}

const CONFETTI: Confetti[] = [
  { color: 'bg-lime-200', left: '12%', size: 'w-2 h-2', top: '8%' },
  { color: 'bg-yellow-peach', left: '22%', size: 'w-1 h-1', top: '19.5%' },
  { color: 'bg-white', left: '8%', size: 'w-1.5 h-1.5', top: '39%' },
  { color: 'bg-hotpink-focus', left: '84.5%', size: 'w-1.5 h-1.5', top: '11.5%' },
  { color: 'bg-lime-200', left: '91%', size: 'w-2 h-2', top: '31%' },
]

export default function CtaSection(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')

  return (
    <section className="bg-lavender-light py-8 md:py-10">
      <SectionContainer>
        <div className="relative flex w-full flex-col items-center gap-4 overflow-hidden rounded-24 bg-gradient-v4-cta-band-mobile md:bg-gradient-v4-cta-band px-6 py-10 md:min-h-132 md:justify-center md:gap-6 md:px-16 md:py-12">
          {CONFETTI.map((confetti) => (
            <span
              aria-hidden
              className={`absolute hidden rounded-0.5 md:block ${confetti.color} ${confetti.size}`}
              key={`${confetti.left}-${confetti.top}`}
              style={{ left: confetti.left, top: confetti.top }}
            />
          ))}

          <ResponsiveImage
            className="absolute -left-3.5 top-1/4 z-0 hidden md:block"
            height={338}
            imageClassName="w-69 h-auto"
            srcKey="landing/v4/cta/lightbulb.png"
            width={600}
          />

          <h2 className="relative z-10 order-1 max-w-196 text-center font-black leading-tight tracking-tighten text-white text-h4 md:text-v4-display">
            {t('v4.cta.headline')}
          </h2>

          <p className="relative z-10 order-3 text-center text-white/75 text-sm md:order-2 md:text-5">
            {t('v4.cta.subline')}
          </p>

          <div className="relative z-10 order-2 md:order-3">
            <LandingCtaButton analyticsLabel="landing_v4_final_cta" uppercase>
              {t('v4.cta.button')}
            </LandingCtaButton>
          </div>

          <ResponsiveImage
            className="relative z-0 order-4 mx-auto md:absolute md:bottom-20 md:right-20 md:mx-0"
            height={319}
            imageClassName="w-24.5 h-auto md:w-35"
            srcKey="landing/v4/cta/treasure-chest.png"
            width={400}
          />
        </div>
      </SectionContainer>
    </section>
  )
}
